import { call, type Env } from '../../lib/api';
import type { Command, Lang, Scenario, SimConfig, Timed } from './engine';

export interface JobRow { id: string; kind: 'live' | 'upload'; startedAt: string; endedAt: string | null; state: string; pool: string | null; language: string | null; mediaS: number | null }
interface Tbl { columns: string[]; rows: unknown[][] }

export async function fetchJobs(env: Env, from: Date, to: Date): Promise<JobRow[]> {
  const qs = new URLSearchParams({ from: from.toISOString(), to: to.toISOString() });
  const t = await call<Tbl>(env, `/admin/analytics/engine-jobs?${qs}`);
  return t.rows.map((r) => Object.fromEntries(t.columns.map((c, i) => [c, r[i]])) as unknown as JobRow);
}

export const langOf = (j: JobRow): Lang => (j.pool === 'engine-en' || (j.language ?? '').toLowerCase().startsWith('en') ? 'english' : 'multilingual');
const unix = (s: string) => Date.parse(s) / 1000;

export function arrival(j: JobRow, t0: number, fileSpeed: number): Command {
  const start = Math.max(unix(j.startedAt), t0);
  const life = j.endedAt ? Math.max(unix(j.endedAt) - start, 1) : null;
  const kind = j.kind === 'live' ? 'live' : 'file';
  return { cmd: 'arrive', kind, lang: langOf(j), lifeS: life, workS: kind === 'file' ? (j.mediaS ? j.mediaS / fileSpeed : life) : null, ext: j.id };
}

export function scenarioOf(jobs: JobRow[], from: Date, to: Date, cfg: SimConfig, source: string): Scenario {
  const t0 = from.getTime() / 1000;
  const config: SimConfig = { ...cfg, traffic: { ...cfg.traffic, generate: false } };
  const timeline: Timed[] = jobs
    .map((j) => ({ t: Math.floor(Math.max(unix(j.startedAt) - t0, 0)) + 0.5, command: arrival(j, t0, cfg.traffic.fileSpeed) }))
    .sort((a, b) => a.t - b.t);
  const label = `${source} ${from.toISOString().slice(0, 16)} → ${to.toISOString().slice(0, 16)} (${jobs.length} recordings)`;
  return { version: 1, source, label, t0Unix: t0, config, timeline, endT: (to.getTime() - from.getTime()) / 1000, fresh: true };
}
